import styled from 'styled-components/macro';
import { LabelSaleS, LabelSaleL, LabelSustainable } from '@yme/assets/icons';
import { defaultTransparent, colorCoreWhite1000 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { ellipsisEndingLine } from '@yme/utils/styles';
export const LabelStyled = styled(FlexWrapper) `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: ${({ isMobileView = false }) => (isMobileView ? '4px 8px' : '4px 12px')};
  gap: 10px;

  color: ${colorCoreWhite1000};
  border-radius: ${CORNER_RADIUS.xs};
  background-color: ${({ backgroundColor = defaultTransparent }) => backgroundColor};

  ${ellipsisEndingLine}

  flex: 0 0 auto;

  height: fit-content;
`;
export const LabelSaleStyled = styled(FlexWrapper) `
  position: relative;
  box-sizing: border-box;
  align-items: center;
  padding: 0;

  background-color: ${({ backgroundColor }) => backgroundColor};

  height: ${({ isMobileView = false }) => (isMobileView ? '24px' : '32px')};

  --label-mobile-width-first: 8px;
  --label-mobile-width-second: 23px;

  --label-desktop-width-first: 12px;
  --label-desktop-width-second: 30px;

  --label-width-first: ${({ isMobileView = false }) => isMobileView ? 'var(--label-mobile-width-first)' : 'var(--label-desktop-width-first)'};

  --label-width-second: ${({ isMobileView = false }) => isMobileView ? 'var(--label-mobile-width-second)' : 'var(--label-desktop-width-second)'};

  margin-left: var(--label-width-first);
  margin-right: var(--label-width-second);

  z-index: ${Z_INDEX.level1};

  ${RegularTextLevel3} {
    color: ${colorCoreWhite1000};
  }

  &::after,
  &::before {
    content: '';
    position: absolute;
    display: block;
    background-size: cover;
    background-repeat: no-repeat;
    top: 0;
    height: 100%;

    min-height: ${({ isMobileView = false }) => (isMobileView ? '24px' : '32px')};

    background: ${({ isMobileView = false }) => isMobileView ? `url(${LabelSaleS})` : `url(${LabelSaleL})`};
  }

  &::before {
    background-position: 0;

    width: var(--label-width-first);

    z-index: ${Z_INDEX.levelNegative1};

    ${({ isRightToLeft }) => isRightToLeft && 'transform: rotate(180deg);'}
    ${({ isRightToLeft }) => isRightToLeft
    ? 'right: calc(-1 * var(--label-width-first));'
    : 'left: calc(-1 * var(--label-width-first));'}
  }

  &::after {
    background-position: 100% 50%;

    width: var(--label-width-second);

    ${({ isRightToLeft }) => isRightToLeft
    ? 'left: calc(-1 * var(--label-width-second));'
    : 'right: calc(-1 * var(--label-width-second));'}
    ${({ isRightToLeft }) => isRightToLeft && 'transform: rotate(180deg);'}
  }
`;
export const FlexWrapperStyled = styled(FlexWrapper) `
  position: absolute;
  white-space: nowrap;
  top: 16px;
  left: 16px;
  gap: 10px;
`;
export const LabelSustainableStyled = styled(LabelStyled) `
  position: relative;

  --sustainable-label-indents: ${({ isMobileView = false }) => isMobileView ? '4px 8px 4px 24px' : '4px 12px 4px 36px'};

  --sustainable-label-indents-rtl: ${({ isMobileView = false }) => isMobileView ? '4px 24px 4px 8px' : '4px 36px 4px 12px'};

  padding: ${({ isRightToLeft = false }) => isRightToLeft ? 'var(--sustainable-label-indents-rtl)' : 'var(--sustainable-label-indents)'};

  &::before {
    content: '';
    position: absolute;
    display: block;
    background: url(${LabelSustainable});
    background-size: cover;
    background-repeat: no-repeat;
    top: 0;
    height: 100%;

    background-position: ${({ isMobileView = false }) => (isMobileView ? '0px 50%' : '5px 50%')};

    width: ${({ isMobileView = false }) => (isMobileView ? '24px' : '36px')};

    ${({ isRightToLeft }) => (isRightToLeft ? 'right: 0;' : 'left: 0;')}
    ${({ isRightToLeft }) => isRightToLeft && 'transform: scaleX(-1);'}
  }
`;
